import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { AuthShell } from "@/pages/Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Passwort vergessen" subtitle="Wir senden Ihnen einen Link zum Zurücksetzen.">
      {sent ? (
        <div className="text-center space-y-4" data-testid="forgot-confirmation">
          <div className="mx-auto h-14 w-14 rounded-full bg-green-50 flex items-center justify-center">
            <MailCheck className="h-7 w-7 text-green-600" />
          </div>
          <p className="text-slate-600">Falls diese E-Mail registriert ist, wurde ein Link zum Zurücksetzen gesendet.</p>
          <Link to="/login" className="inline-block text-primary font-semibold hover:underline">Zurück zur Anmeldung</Link>
        </div>
      ) : (
        <>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="email">E-Mail</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5 h-11" data-testid="forgot-email-input" placeholder="name@firma.de" />
            </div>
            {error && <p className="text-sm text-red-600">{error}</p>}
            <Button type="submit" className="w-full h-11" disabled={loading} data-testid="forgot-submit-btn">
              {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Link senden"}
            </Button>
          </form>
          <p className="mt-6 text-center text-sm text-slate-500">
            <Link to="/login" className="text-primary font-semibold hover:underline">Zurück zur Anmeldung</Link>
          </p>
        </>
      )}
    </AuthShell>
  );
}
